module.exports = {
      id: "mynews-usage",
      viewBox: "0 0 13.581 13.581",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#mynews",
      toString: function () {
        return this.url;
      }
    }